import postsContent from './postsContent';

// Resolved markdown, kept module-level so a post already fetched before the
// first render can be read synchronously during it. Without this, PostPage
// renders an empty article on its first pass and fills it from an effect,
// which discards the prerendered body and shifts everything below it.
const cache = new Map();

export const hasPostContent = (filename) => Boolean(filename && postsContent[filename]);

// Returns the markdown if it is already resolved, otherwise null. Callers must
// treat null as "not loaded yet" rather than "empty", since a post that failed
// to load also has no content.
export const getLoadedPostContent = (filename) =>
  filename && cache.has(filename) ? cache.get(filename) : null;

export const loadPostContent = (filename) => {
  if (!filename) return Promise.resolve('');
  if (cache.has(filename)) return Promise.resolve(cache.get(filename));

  const loader = postsContent[filename];
  if (!loader) {
    cache.set(filename, '');
    return Promise.resolve('');
  }

  return loader()
    .then((module) => {
      const content = module.default || '';
      cache.set(filename, content);
      return content;
    })
    // Deliberately not cached: a failed chunk request should be retried on the
    // next mount rather than leaving the post permanently blank.
    .catch(() => '');
};

// Mirrors the /blog/:id route in App.js so the markdown chunk for the current
// URL can be resolved before the initial hydration.
export const postFilenameForPath = (pathname) => {
  const path = (pathname || '').replace(/\/+$/, '');
  if (!path.startsWith('/blog/')) return null;

  const slug = path.slice('/blog/'.length);
  if (!slug || slug.includes('/')) return null;

  const filename = `${slug}.md`;
  return postsContent[filename] ? filename : null;
};
